import { render, staticRenderFns } from "./SyncVModelExample.vue?vue&type=template&id=70110408&"
import script from "./SyncVModelExample.vue?vue&type=script&lang=js&"
export * from "./SyncVModelExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports